import type { Locale } from '@upme/view-logic';
import i18next, { type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { commonEn } from './common.en';
import { commonRu } from './common.ru';

const COMMON = { ru: commonRu, en: commonEn };

export interface CreateI18nOptions {
  lng: Locale;
  /** Per-app namespaces: { ru: { onboarding: {...} }, en: {...} } */
  resources: Record<Locale, Record<string, object>>;
}

export function createI18n({ lng, resources }: CreateI18nOptions): i18n {
  const merged = {
    ru: { common: COMMON.ru, ...resources.ru },
    en: { common: COMMON.en, ...resources.en },
  };
  // Все namespaces (common + per-app) — иначе react-i18next warn'ит на useTranslation(ns).
  const ns = Object.keys(merged.ru);
  const instance = i18next.createInstance();
  instance.use(initReactI18next).init({
    lng,
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns,
    interpolation: { escapeValue: false },
    returnNull: false,
    resources: merged,
  });
  return instance;
}
